<div class="ag-name-value ag-status-link">
  <span id="resetGrid" (click)="resetGrid()">Reset Grid</span>
</div>